import React from 'react';

const Card = ({ 
  children, 
  className = '', 
  variant = 'default',
  shadow = true,
  hover = true,
  padding = 'default',
  ...props 
}) => {
  const baseClasses = 'bg-white rounded-lg border transition-all duration-200';
  
  const variantClasses = {
    default: 'border-hemp-green-200',
    success: 'border-hemp-green-300 bg-hemp-green-50',
    warning: 'border-hemp-brown-300 bg-hemp-brown-50',
    danger: 'border-red-300 bg-red-50',
    info: 'border-hemp-leaf-300 bg-hemp-leaf-50',
    feature: 'border-hemp-green-200 bg-white hover:border-hemp-green-300'
  };
  
  const shadowClasses = shadow ? 'shadow-md' : '';
  const hoverClasses = hover ? 'hover:shadow-lg' : '';
  
  const paddingClasses = {
    none: '',
    sm: 'p-4',
    default: 'p-6',
    lg: 'p-8'
  };
  
  const classes = [
    baseClasses,
    variantClasses[variant],
    shadowClasses,
    hoverClasses,
    padding !== 'default' ? paddingClasses[padding] : '',
    className
  ].filter(Boolean).join(' ');
  
  return (
    <div className={classes} {...props}>
      {padding === 'default' ? children : <div className={paddingClasses[padding]}>{children}</div>}
    </div>
  );
};

export const CardHeader = ({ 
  children, 
  className = '', 
  ...props 
}) => {
  const classes = `px-6 py-4 border-b border-gray-200 ${className}`;
  return (
    <div className={classes} {...props}>
      {children}
    </div>
  );
};

export const CardBody = ({ 
  children, 
  className = '', 
  ...props 
}) => {
  const classes = `p-6 ${className}`;
  return (
    <div className={classes} {...props}>
      {children}
    </div>
  );
};

export const CardFooter = ({ 
  children, 
  className = '', 
  ...props 
}) => {
  const classes = `px-6 py-4 border-t border-gray-200 ${className}`;
  return (
    <div className={classes} {...props}>
      {children}
    </div>
  );
};

export default Card;
